import { Component, computed, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { PercentageValuePipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import type { AiScoresModel } from "../../../models";
import { CountUpComponent } from "../../count-up";

type AiCardMetric = {
  label: string;
  value: number | null;
  color: string;
  progress: number;
};

@Component({
  selector: "adaa-ai-performance-card",
  templateUrl: "./ai-performance-card.html",
  styleUrl: "./ai-performance-card.scss",
  imports: [PercentageValuePipe, TranslatePipe, CountUpComponent],
})
export class AiPerformanceCardComponent {
  readonly data = input.required<AiScoresModel>();
  readonly name = input.required<string>();

  readonly metrics = computed<AiCardMetric[]>(() => {
    const data = this.data();
    return [
      this._metric("data_entry.performance", data.score, data.scoreColor),
      this._metric("dashboard.accumulated_performance", data.accumulatedScore, data.accumulatedScoreColor),
      this._metric("landingPage.entity_page.overall_performance", data.overallScore, data.overallScoreColor),
    ];
  });

  readonly accumulatedColor = computed(() => this.metrics()[1].color);

  readonly defaultColor = Constants.COLOR_CODES[Constants.CONSTANT_COLORS.EVALUATION_GRAY];
  readonly valueFontSize = "0.875rem";

  public getColor(code: number) {
    return Constants.COLOR_CODES[code];
  }

  private _metric(label: string, value: number | null, colorCode: number | null): AiCardMetric {
    return {
      label,
      value,
      color: this._evaluationColor(value, colorCode),
      progress: this._progress(value),
    };
  }

  private _evaluationColor(value: number | null, colorCode: number | null) {
    if (!AdaaHelper.isDefined(value) || !AdaaHelper.isDefined(colorCode)) return this.defaultColor;
    return this.getColor(colorCode);
  }

  private _progress(value: number | null) {
    if (!AdaaHelper.isDefined(value)) return 0;
    return Math.max(0, Math.min(100, value));
  }
}
